import React from 'react'
import { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useWindowSize } from '../../context/WindowSizeContext'
import styles from './project1.module.css'


export default function Project1({position}) {
  const {innerWidth,innerHeight}=useWindowSize();
  const [isAnimated,setIsAnimated]=useState(false)
  const navigate=useNavigate()


  useEffect(()=>{
    if(innerWidth <=850){
    if(position.top < innerHeight /2 && position.top > 0)
       setIsAnimated(true)
    else if(position.top > innerHeight /2)
       setIsAnimated(false)
    else if(position.bottom < innerHeight /2 )
       setIsAnimated(false)
    }
  },[innerHeight, innerWidth, position.bottom, position.top, setIsAnimated])

  const navigateToProject1=()=>{
    navigate('/project1')
  }

  return (
    <div className={styles.project1} onClick={navigateToProject1}>
       <div className={isAnimated ? styles.img2 : styles.img}>
        <div className={isAnimated ? styles.backdrop2 : styles.backdrop}>
          <h3 className={styles["project-name"]}>Classified Website</h3>
          <p className={styles["project-details"]}>React, Typescript, Node.js, MySQL, Responsive Design</p>
        </div>
       </div>
    </div>
  )
}
